// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__h5XNI","cell":"ColumnAccessor_cell__3H26p","firstCellAccent":"ColumnAccessor_firstCellAccent__3O1nX"};